/* eslint-disable */
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: bun run autoexport.
//

export { default as CMYK } from "./CMYK.icc"
export { default as fogra51 } from "./fogra51.icc"
export { default as fogra52 } from "./fogra52.icc"
